import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store"

const selector = (state: StoreState) => state.contact;

export const contactSelector = {
    contact: createSelector(selector, (contact) => contact.contact)
}